<div class="flex items-center">
  <!-- the tooltip sits on a wrapper because a disabled button receives no hover events -->
  <span [iTooltip]="params.tooltip">
    <button
      iButton
      [iDropdownMenuTrigger]="gridMenu"
      placement="bottom-end"
      variant="ghost"
      size="sm"
      [disabled]="!!params.disabled"
    >
      <IIcon [name]="params.icon" />
      {{ params.label }}
    </button>
  </span>

  <ng-template #gridMenu>
    <IDropdownMenu>
      @for (itemGroup of params.items; track $index) {
        @for (item of itemGroup; track item.label) {
          @if (item.onClick) {
            <button
              iDropdownMenuItem
              [disabled]="item.disabled"
              [variant]="item.variant || 'default'"
              [iTooltip]="item.tooltip"
              (click)="item.onClick()"
            >
              @if (item.icon) {
                <IIcon [name]="item.icon" />
              }
              {{ item.label }}
            </button>
          } @else if (item.url) {
            <a iDropdownMenuItem [routerLink]="item.url" queryParamsHandling="merge" [iTooltip]="item.tooltip">
              @if (item.icon) {
                <IIcon [name]="item.icon" />
              }
              {{ item.label }}
            </a>
          } @else if (item.href) {
            <a iDropdownMenuItem [href]="item.href" target="_blank" [iTooltip]="item.tooltip">
              @if (item.icon) {
                <IIcon [name]="item.icon" />
              }
              {{ item.label }}
            </a>
          }
        }
        @if (!$last) {
          <IDropdownMenuSeparator />
        }
      }
    </IDropdownMenu>
  </ng-template>
</div>
